<div id="attribute"
  style="display: flex; flex-direction: column; height: 100%; max-height: 100%; box-sizing: border-box;">
  <div class="title-head" fxLayout="row" fxLayoutAlign="space-between center" color="primary" style="flex-shrink: 0;">
    <span>
      {{headerName}}
    </span>
    <button [attr.guide]="'common-download-btn-1' + '__' + sanitizedUrl" mat-icon-button>
      <mat-icon (click)="close()">
        close
      </mat-icon>
    </button>
  </div>
  <div class="padding-11" style="overflow-y: auto; overflow-x: hidden; flex: 1;">
    <div fxLayout="column">

      <div class="products-padding " style="overflow-x: auto;">
        <div fxLayout="row wrap" fxLayoutAlign="start start" fxLayoutGap="15px">
          <form fxFlex="100" [formGroup]="firstFormGroup">
            <div class="padding-10">

              <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="10px">
                <mat-form-field fxFlex appearance="outline" fxLayoutGap="10px">
                  <mat-label>Page</mat-label>
                  <input [attr.guide]="'common-download-inp-page' + '__' + sanitizedUrl" matInput formControlName="page"
                    (blur)="onPageBlur()" />
                </mat-form-field>
              </div>
              <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="10px">
                <mat-form-field fxFlex appearance="outline" fxLayoutGap="10px">
                  <mat-label>Size</mat-label>
                  <input [attr.guide]="'common-download-inp-size' + '__' + sanitizedUrl" matInput formControlName="size"
                    (blur)="onSizeBlur()" />
                </mat-form-field>
              </div>
              <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="10px">
                <mat-form-field fxFlex appearance="outline" fxLayoutGap="10px">
                  <mat-label>Sort Value</mat-label>
                  <mat-select formControlName="sort">
                    <mat-option *ngFor="let status of sortObject" [value]="status.property">
                      {{status.name}}
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="firstFormGroup.controls.sort.errors?.required">
                    Please fill out this Field.
                  </mat-error>
                </mat-form-field>
              </div>

              <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="10px">
                <mat-form-field appearance="outline" fxFlex>
                  <mat-label>Sord By</mat-label>
                  <mat-select formControlName="sortBy">
                    <mat-option *ngFor="let status of booleanField" [value]="status.value">
                      {{status.viewValue}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>

              <!-- <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="10px">
                <mat-form-field appearance="outline" fxFlex>
                  <mat-label>Download Mode</mat-label>
                  <mat-select formControlName="downloadMode">
                    <mat-option *ngFor="let status of downloadMode" [value]="status.value">
                      {{status.viewValue}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div> -->
            </div>
          </form>


          <div *ngFor="let filter of filterSelectObj;let i=index; " fxFlex="100">


            <div style="width: 100%;">
              <mat-form-field appearance="outline" fxFlex="100"
                *ngIf="filter.type!='date'&&filter.type!='disable'&&filter.type!='time'" style="margin-left: 5px;">
                <mat-label>{{filter.name | uppercase }}</mat-label>


                <mat-select [(ngModel)]="selectedValues[i]"
                  (selectionChange)="filterColumnMultiSelect($event,i,filter.type)" multiple
                  [disableOptionCentering]="true" *ngIf="filter.type=='multiSelect' || filter.type=='multiselect'">


                  <ng-container
                    *ngIf="filter.property =='stage' || filter.name =='Deal Stage' || filter.name == 'Stage' || filter.name == 'Stage Name' || filter.property == 'b.status_name' ||filter.property =='a.stage' || filter.property =='b.statusName'">
                    <mat-option *ngFor="let opt of filteredlDealStatusTypeList; let i=index;" [value]="opt.statusName">
                      {{opt.statusName}}
                    </mat-option>
                  </ng-container>

                  <ng-container *ngIf="filter.property =='tagName'">
                    <mat-option *ngFor="let opt of filteredtagsTypeList; let i=index;" [value]="opt.statusName">
                      {{opt.statusName}}
                    </mat-option>
                  </ng-container>

                  <ng-container
                    *ngIf="filter.property =='statusName'
                                ||filter.property =='c.status_name'
                                ||filter.name =='Status Name'||filter.name =='Life Stage'||filter.name =='Lead Status'">
                    <mat-option *ngFor="let opt of filtereddropdownTypeList; let i=index;" [value]="opt.statusName">
                      {{opt.statusName}}
                    </mat-option>
                  </ng-container>



                  <ng-container *ngIf="filter.property =='a.stage' || filter.property =='b.statusName'">
                    <mat-option *ngFor="let opt of filteredlDealStatusTypeList; let i=index;" [value]="opt.statusName">
                      {{opt.statusName}}
                    </mat-option>
                  </ng-container>




                  <ng-container *ngIf="filter.property =='sourceName'
                                ||filter.property =='g.source_name'
                                ||filter.name =='Source Name'||filter.name =='Lead Source'">
                    <mat-option *ngFor="let opt of filteredLeadSourceTypeList; let i=index;" [value]="opt.sourceName">
                      {{opt.sourceName}}
                    </mat-option>
                  </ng-container>


                  <ng-container *ngIf="filter.name == 'Owner'
                                || filter.name == 'Created By'
                                || filter.property == 'a.owner_id'
                                || filter.property == 'ownerEmail'
                                || filter.property == 'createdBy'
                                || filter.property == 'created_by'
                                || filter.property == 'a.created_by'|| filter.property == 'a.user_name'">
                    <mat-option *ngFor="let opt of filtereduserTypeList; let i=index;" [value]="opt.email">
                      {{opt.email}}
                    </mat-option>
                  </ng-container>


                  <ng-container *ngIf="filter.name =='Type of Service'">
                    <mat-option *ngFor="let opt of filteredPayemntTypeList; let i=index;" [value]="opt.name">
                      {{opt.name}}
                    </mat-option>
                  </ng-container>


                  <ng-container *ngIf="filter.name =='Activity Type'">
                    <mat-option *ngFor="let opt of filteredActivityTypeList; let i=index;" [value]="opt.activityType">
                      {{opt.activityType}}
                    </mat-option>
                  </ng-container>

                  <ng-container *ngIf="filter.property =='industryType' || filter.name =='Industry Type'">
                    <mat-option *ngFor="let opt of filteredindustryTypeList; let i=index;" [value]="opt.statusName">
                      {{opt.statusName}}
                    </mat-option>
                  </ng-container>

                  <ng-container *ngIf="filter.property =='businessType' || filter.name =='Busniess Type'">
                    <mat-option *ngFor="let opt of filteredBusinessTypeList; let i=index;" [value]="opt.statusName">
                      {{opt.statusName}}
                    </mat-option>
                  </ng-container>
                  <ng-container
                    *ngIf="filter.property =='warehouseName' || filter.property == 'warehouse' || filter.name == 'Location' || filter.name == 'Warehouse' || filter.name == 'Warehouse Name'">
                    <mat-option *ngFor="let opt of filteredWarehouseTypeList; let i=index;"
                      [value]="opt.name || opt.warehouseName || opt.viewValue">
                      {{opt.name || opt.warehouseName || opt.viewValue}}
                    </mat-option>
                  </ng-container>

                  <ng-container
                    *ngIf="filter.property =='supplier' || filter.name == 'Suppliers' || filter.name == 'Supplier' || filter.property == 'supplierName' || filter.property == 'supplierId'">
                    <mat-option *ngFor="let opt of filteredsupplierTypeList; let i=index;"
                      [value]="opt.name || opt.company || opt.supplier || opt.viewValue">
                      {{opt.name || opt.company || opt.supplier || opt.viewValue}}
                    </mat-option>
                  </ng-container>

                  <ng-container
                    *ngIf="filter.name == 'Tax Rate' || filter.name == 'Tax Rate Name' || filter.property == 'taxRateId' || filter.property == 'tax'">
                    <mat-option *ngFor="let opt of filteredTaxRateTypeList; let i=index;"
                      [value]="opt.name || opt.taxName">
                      {{opt.name || opt.taxName}}
                    </mat-option>
                  </ng-container>
                  <ng-container *ngIf="shouldUseInlineOptions(filter)">
                    <mat-option [disabled]="item.value=='disabled1'"
                      *ngFor="let item of (filter._filteredOptions || filter.options); trackBy: trackByValue"
                      [value]="item.value">
                      {{item.viewValue || item.value}}
                    </mat-option>
                  </ng-container>

                </mat-select>

                <mat-select [disableOptionCentering]="true" [(ngModel)]="selectedValues[i]" [(value)]="this[filter['position']]   == undefined ? 'ALL'
           : this[filter['position']]" (selectionChange)="filterColumn($event,i,filter.type)"
                  *ngIf="filter.type=='select'">
                  <mat-option value="ALL">(ALL)</mat-option>

                  <ng-container *ngIf="!url.includes('whatsAppBotFlows') && !url.includes('leadMeetingSummaryReport')">
                    <ng-container
                      *ngIf="(filter.property == 'a.status' || filter.name == 'Status') && filteredUserCallStatusTypeList?.length > 0">
                      <mat-option *ngFor="let opt of filteredUserCallStatusTypeList; let k = index"
                        [value]="opt.Status">{{ opt.Status }}</mat-option>
                    </ng-container>
                  </ng-container>

                  <ng-container *ngIf="filter.property =='statusName'
                                ||filter.name =='Status Name'
                                ||filter.name =='Life Stage'
                                ">
                    <mat-option *ngFor="let opt of filtereddropdownTypeList; let i=index;" [value]="opt.statusName">
                      {{opt.statusName}}
                    </mat-option>
                  </ng-container>



                  <ng-container *ngIf="filter.property =='sourceName'||filter.name =='Source Name'">
                    <mat-option *ngFor="let opt of filteredLeadSourceTypeList; let i=index;" [value]="opt.sourceName">
                      {{opt.sourceName}}
                    </mat-option>
                  </ng-container>

                  <ng-container *ngIf="filter.property =='tagName'">
                    <mat-option *ngFor="let opt of filteredtagsTypeList; let i=index;" [value]="opt.statusName">
                      {{opt.statusName}}
                    </mat-option>
                  </ng-container>

                  <ng-container *ngIf="filter.property =='stage' || filter.name =='Deal Stage'">
                    <mat-option *ngFor="let opt of filteredlDealStatusTypeList; let i=index;" [value]="opt.statusName">
                      {{opt.statusName}}
                    </mat-option>
                  </ng-container>


                  <ng-container *ngIf="filter.name == 'Owner'
                                || filter.name == 'Created By'
                                || filter.property == 'a.owner_id'
                                || filter.property == 'ownerEmail'
                                || filter.property == 'createdBy'
                                || filter.property == 'created_by'
                                || filter.property == 'a.created_by'|| filter.property == 'a.user_name'">
                    <mat-option *ngFor="let opt of filtereduserTypeList; let i=index;" [value]="opt.email">
                      {{opt.email}}
                    </mat-option>
                  </ng-container>


                  <ng-container *ngIf="filter.property =='industryType' || filter.name =='Industry Type'">
                    <mat-option *ngFor="let opt of filteredindustryTypeList; let i=index;" [value]="opt.statusName">
                      {{opt.statusName}}
                    </mat-option>
                  </ng-container>

                  <ng-container *ngIf="filter.property =='businessType' || filter.name =='Busniess Type'">
                    <mat-option *ngFor="let opt of filteredBusinessTypeList; let i=index;" [value]="opt.statusName">
                      {{opt.statusName}}
                    </mat-option>
                  </ng-container>

                  <ng-container *ngIf="filter.name =='Activity Type'">
                    <mat-option *ngFor="let opt of filteredActivityTypeList; let i=index;" [value]="opt.activityType">
                      {{opt.activityType}}
                    </mat-option>
                  </ng-container>


                  <ng-container *ngIf="shouldUseInlineOptions(filter)">
                    <mat-option [disabled]="item.value=='disabled1'"
                      *ngFor="let item of (filter._filteredOptions || filter.options); trackBy: trackByValue"
                      [value]="item.value">{{item.viewValue || item.value}}</mat-option>
                  </ng-container>
                  <ng-container
                    *ngIf="filter.property =='warehouseName' || filter.property == 'warehouse' || filter.name == 'Location' || filter.name == 'Warehouse' || filter.name == 'Warehouse Name'">
                    <mat-option *ngFor="let opt of filteredWarehouseTypeList; let i=index;"
                      [value]="opt.name || opt.warehouseName || opt.viewValue">
                      {{opt.name || opt.warehouseName || opt.viewValue}}
                    </mat-option>
                  </ng-container>

                  <ng-container
                    *ngIf="filter.property =='supplier' || filter.name == 'Suppliers' || filter.name == 'Supplier' || filter.property == 'supplierName' || filter.property == 'supplierId'">
                    <mat-option *ngFor="let opt of filteredsupplierTypeList; let i=index;"
                      [value]="opt.name || opt.company || opt.supplier || opt.viewValue">
                      {{opt.name || opt.company || opt.supplier || opt.viewValue}}
                    </mat-option>
                  </ng-container>

                  <ng-container
                    *ngIf="filter.name == 'Tax Rate' || filter.name == 'Tax Rate Name' || filter.property == 'taxRateId' || filter.property == 'tax'">
                    <mat-option *ngFor="let opt of filteredTaxRateTypeList; let i=index;"
                      [value]="opt.name || opt.taxName">
                      {{opt.name || opt.taxName}}
                    </mat-option>
                  </ng-container>


                </mat-select>


                <input [attr.guide]="'common-download-inp-2' + '__' + sanitizedUrl" [autocomplete]="'off'" #myText
                  trim="blur" (keyup)="filterColumnText($event,i,filter.modelValue)" *ngIf="filter.type=='text' "
                  matInput [(ngModel)]="filter.modelValue" />

                <input [attr.guide]="'common-download-inp-3' + '__' + sanitizedUrl" [autocomplete]="'off'" #myText
                  trim="blur" numbersOnly (keyup)="filterColumnText($event,i,filter.modelValue)"
                  *ngIf="filter.type=='id' " matInput [(ngModel)]="filter.modelValue" />

                <input [attr.guide]="'common-download-inp-4' + '__' + sanitizedUrl" [autocomplete]="'off'" #myText
                  (keyup)="filterColumnText($event,i,filter.modelValue)" numbersOnly *ngIf="filter.type=='price' "
                  matInput [(ngModel)]="filter.modelValue" />
              </mat-form-field>

              <div *ngIf="filter.type == 'time'" class="time-picker-container"
                style="margin-left: 5px; margin-bottom: 20px;">
                <mat-label style="display: block; font-size: 12px; color: rgba(0,0,0,0.6); margin-bottom: 8px;">
                  {{filter.name | uppercase}}
                </mat-label>
                <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
                  <mat-form-field appearance="outline" style="width: 80px;">
                    <mat-label>HH</mat-label>
                    <mat-select [(ngModel)]="timeValues[i].hh" (selectionChange)="onTimeChange(i, filter)">
                      <mat-option *ngFor="let h of hoursList" [value]="h">{{h}}</mat-option>
                    </mat-select>
                  </mat-form-field>
                  <span class="time-separator" style="font-weight: bold; font-size: 1.2rem; margin-top: -15px;">:</span>
                  <mat-form-field appearance="outline" style="width: 80px;">
                    <mat-label>MM</mat-label>
                    <mat-select [(ngModel)]="timeValues[i].mm" (selectionChange)="onTimeChange(i, filter)">
                      <mat-option *ngFor="let m of minutesList" [value]="m">{{m}}</mat-option>
                    </mat-select>
                  </mat-form-field>
                  <mat-form-field appearance="outline" style="width: 100px;">
                    <mat-label>AM/PM</mat-label>
                    <mat-select [(ngModel)]="timeValues[i].ampm" (selectionChange)="onTimeChange(i, filter)">
                      <mat-option *ngFor="let a of ampmList" [value]="a">{{a}}</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>
            </div>

            <div style="width: 100%;" [formGroup]="filtersForm">
              <mat-form-field fxFlex="100" appearance="outline"
                *ngIf=" columns[i] && columns[i].visible&&filter.type=='date'&&filter.type=='date'&&filter.type!='disable'">
                <mat-label>{{filter.name | uppercase }}</mat-label>
                <mat-date-range-input [formGroup]="filtersForm.get('ranges')['controls'][i]" [rangePicker]="picker">
                  <input [attr.guide]="'common-download-inp-start' + '__' + sanitizedUrl" style="width: 100%;" disabled
                    [autocomplete]="'off'" disabled (dateChange)="start($event,'start',i)" matStartDate
                    formControlName="start" placeholder="Start date" />
                  <input [attr.guide]="'common-download-inp-end' + '__' + sanitizedUrl" style="width: 100%;"
                    [autocomplete]="'off'" disabled (dateChange)="end($event,'end',i)" matEndDate formControlName="end"
                    placeholder="End date" />
                </mat-date-range-input>
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-date-range-picker color="accent" disabled="false" #picker></mat-date-range-picker>

              </mat-form-field>


            </div>




          </div>
          <div class="padding-10" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="20px">
            <button [attr.guide]="'common-download-btn-reset' + '__' + sanitizedUrl" mat-raised-button
              (click)="resetFilters()">Reset</button>
            <button [attr.guide]="'common-download-btn-5' + '__' + sanitizedUrl" mat-raised-button mat-dialog-close
              tabindex="-1">Cancel</button>
            <button [attr.guide]="'common-download-btn-6' + '__' + sanitizedUrl" (click)=searchFilter()
              [disabled]="downloadDataComplete != 'OK'" mat-raised-button>
              {{downloadDataComplete}}
              <mat-icon *ngIf="downloadDataComplete != 'OK'">
                <mat-spinner color="primary" diameter="20"></mat-spinner>
              </mat-icon>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>